import m2_examRegMenu from '@components/examRegMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    "examRegMenu": m1_examRegMenu,
    'm2ExamRegMenu': m2_examRegMenu,
    "m2Sidebar": m2Sidebar,
  },
  data() {
    return {
      showPrice: false,
      domain: this.$store.state.examInfo.currentExamInfo.domain,
      dialogVisible: false,
      dialogImageUrl: "",
      examRegInfo: {
        region_subject_selections: {}
      },
      tableData: [],
      imgList: [],
      fileList: [],
      cert_pic: {},
      tip: "",
      auditStatus: {},
      payState: {
        succeed: 2,
      },
      tableInfoData: []
    };
  },
  methods: {
    getData: function () {
      this.examRegInfo = this.$store.state.examRegInfo.examRegInfo;
      this.auditStatus = auditStatus;
      console.log(auditStatus)
      let num = 0;
      this.examRegInfo.text_info_confs.forEach((item, index) => {
        if (item.type == 8) {
          if (item.value.length > 0) {
            this.tableInfoData.push(item);
          }
        }
      })
      this.examRegInfo.pic_info_confs.forEach((item, index) => {
        if (item._item_type === "cert_pic") {
          this.cert_pic = {
            url: null,
            file_guid: null
          };
          this.getImgUrl(item.value, index, "cert_pic");
          num++;
        } else {
          if (item.value) {
            this.imgList.push({
              url: null,
              file_guid: null,
              name: item.name
            });
            this.getImgUrl(item.value, index - num, "img");
          } else {
            num = num + 1
          }
        }

      });
      this.examRegInfo.file_info_confs.forEach((item, index) => {
        if (item.value) {
          this.getImgUrl(item.value, index, "file");
        }
      });
    },
    //获取页面提示信息
    getTip: function () {
      this.$http
        .get(globalProvider.serviceUrl("e_reg/g/sts/{key_code}"), {
          params: {
            key_code: tipKeyCode.exam_reg_success
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data != null) {
              this.tip = data.body.data.key_value;
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    downloadResume() {
      this.$http
        .get(globalProvider.serviceUrl("erm/cv_pdf/{reg_id}"), {
          params: {
            reg_id: this.examRegInfo.exam_registration_id
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            location.href = data.body.data;
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    modifyInfo: function () {
      let reg_info_operation = 2;
      this.$confirm(
        "考生修改信息后，请务必在【确认信息】页面提交报考信息",
        "注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
      )
        .then(() => {
          this.$http
            .get(
              globalProvider.serviceUrl(
                "e_reg/g/eri/{reg_id}/{reg_info_operation}"
              ), {
              params: {
                reg_id: this.examRegInfo.exam_registration_id,
                reg_info_operation: reg_info_operation
              }
            }
            )
            .then(data => {
              if (data.body.code === resultCode.Success) {
                this.$store.commit("setExamRegInfo", data.body.data);
                this.$router.push({
                  name: "default.examReg.baseCollection"
                });
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message));
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    payOrder: function () {
      this.$router.push({
        name: "default.examReg.payOrder"
      });
    },
    getImgUrl: function (proc_id, id, type_id) {
      this.$http
        .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
          params: {
            proc_id: proc_id
          }
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            if (type_id === "img") {
              this.imgList[id].url = data.body.data[0].link;
              this.imgList[id].file_guid = data.body.data[0].file_guid;
            }
            if (type_id === "file") {
              for (let item of data.body.data) {
                this.fileList.push({
                  file_id: item.file_guid,
                  name: item.name
                });
              }
            }
            if (type_id === "cert_pic") {
              this.cert_pic.url = data.body.data[0].link;
              this.cert_pic.file_guid = data.body.data[0].file_guid;
            }
          }
        });
    },
    download: function (file_guid) {
      this.$http
        .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/single/{file_guid}"), {
          params: {
            file_guid: file_guid
          }
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.src = data.body.data.link;
              elemIF.style.display = "none";
              document.body.appendChild(elemIF);
            } catch (e) {
              zzrw.alert("下载异常！");
            }
          }
        });
    },
    handlePictureCardPreview(file_guid) {
      this.$http
        .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/single/{file_guid}"), {
          params: {
            file_guid: file_guid
          }
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            this.dialogImageUrl = data.body.data.link;
            this.dialogVisible = true;
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    //获取提交的报考信息
    getRegModel: function (reg_id) {
      let reg_info_operation = 1;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: reg_info_operation
          }
        }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$store.commit("setExamRegInfo", data.body.data);
            this.tableData = [];
            this.imgList = [];
            this.fileList = [];
            this.getData();
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    goRegList: function () {
      this.$router.push({
        name: "default_myRegister"
      });
    },
    isShowPrice() {
      this.showPrice = globalProvider.isGuideDomain(this.domain);
    }
  },
  created: function () {
    this.$store.commit("setHeaderState", "3");
    this.getRegModel(
      this.$store.state.examRegInfo.examRegInfo.exam_registration_id
    );
    this.getTip();
    this.isShowPrice()
  }
};